// frontend_react/src/pages/sales/SalesDashboard.jsx

import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function SalesDashboard() {
  const navigate = useNavigate();

  return (
    <SalesPage>
      <HeaderZone>
        <PageHeading>Ventes</PageHeading>
        <PageSubtitle>
          Raccourcis opérationnels vers les KPI, rapports de caisse et actions courantes.
        </PageSubtitle>
      </HeaderZone>

      <SalesWorkspace>
        <CardGrid>
          <SalesActionCard onClick={() => navigate("/admin?panel=cash_dashboard")}>
            <span>📊</span>
            <h3>KPI caisse</h3>
            <p>Consulter le chiffre d’affaires, les tickets, le panier moyen et les paiements.</p>
          </SalesActionCard>

          <SalesActionCard onClick={() => navigate("/admin?panel=x_report")}>
            <span>🧾</span>
            <h3>X de caisse</h3>
            <p>Afficher la situation instantanée de la caisse sans clôture.</p>
          </SalesActionCard>

          <SalesActionCard onClick={() => navigate("/admin?panel=z_report")}>
            <span>🔐</span>
            <h3>Clôture Z</h3>
            <p>Clôturer la journée, saisir le fond de caisse et certifier la clôture.</p>
          </SalesActionCard>

          <SalesActionCard onClick={() => navigate("/admin?panel=z_history")}>
            <span>📚</span>
            <h3>Historique Z</h3>
            <p>Consulter, télécharger ou transmettre les clôtures précédentes.</p>
          </SalesActionCard>

          <SalesActionCard disabled>
            <span>🎟️</span>
            <h3>Tickets</h3>
            <p>Rechercher, réimprimer ou envoyer un ticket de caisse.</p>
          </SalesActionCard>

          <SalesActionCard disabled>
            <span>🎁</span>
            <h3>Cartes cadeaux</h3>
            <p>Créer, imprimer, envoyer et suivre les cartes cadeaux.</p>
          </SalesActionCard>
        </CardGrid>
      </SalesWorkspace>
    </SalesPage>
  );
}

const SalesPage = styled.div`
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 1rem 1.5rem 1.5rem;
  margin: 0;
  overflow-x: hidden;
`;

const HeaderZone = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

const PageHeading = styled.h1`
  margin: 0 0 0.4rem;
  color: #f7f7f7;
  font-size: 2rem;
  font-weight: 950;
`;

const PageSubtitle = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 750;
`;

const SalesWorkspace = styled.main`
  width: 100%;
  min-height: calc(100vh - 130px);
  background: #1d263d;
  border-radius: 28px;
  padding: 2rem;
  box-sizing: border-box;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.1rem;
`;

const SalesActionCard = styled.button`
  min-height: 250px;
  background: #202a43;
  border-radius: 18px;
  color: #f7f7f7;
  padding: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: 0.18s ease;
  text-align: left;
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};

  &:hover {
    ${({ disabled }) =>
      !disabled &&
      `
        background: #26324f;
        border-color: rgba(255, 255, 255, 0.28);
        transform: translateY(-2px);
      `}
  }

  span {
    font-size: 2rem;
  }

  h3 {
    margin: 0.8rem 0 0.5rem;
    font-size: 1.17rem;
    font-weight: 950;
  }

  p {
    color: rgba(255, 255, 255, 0.72);
    line-height: 1.45;
    margin: 0;
  }
`;